export const regexPassword = new RegExp(
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*à!çè§"&@#$+=:/;.,?<>îôê°€)(+=._-]{8,}$/,
);
